!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@hotmart/cosmos"] = t() : e["@hotmart/cosmos"] = t();
}(self, function () {
  return function () {
    "use strict";

    var e = {
      7705: function _(e) {
        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var r = "",
                  o = void 0 !== t[5];
              return t[4] && (r += "@supports (".concat(t[4], ") {")), t[2] && (r += "@media ".concat(t[2], " {")), o && (r += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), r += e(t), o && (r += "}"), t[2] && (r += "}"), t[4] && (r += "}"), r;
            }).join("");
          }, t.i = function (e, r, o, n, i) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (o) for (var s = 0; s < this.length; s++) {
              var c = this[s][0];
              null != c && (a[c] = !0);
            }

            for (var l = 0; l < e.length; l++) {
              var d = [].concat(e[l]);
              o && a[d[0]] || (void 0 !== i && (void 0 === d[5] || (d[1] = "@layer".concat(d[5].length > 0 ? " ".concat(d[5]) : "", " {").concat(d[1], "}")), d[5] = i), r && (d[2] ? (d[1] = "@media ".concat(d[2], " {").concat(d[1], "}"), d[2] = r) : d[2] = r), n && (d[4] ? (d[1] = "@supports (".concat(d[4], ") {").concat(d[1], "}"), d[4] = n) : d[4] = "".concat(n)), t.push(d));
            }
          }, t;
        };
      },
      6738: function _(e) {
        e.exports = function (e) {
          return e[1];
        };
      },
      5097: function _(e, t, r) {
        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var o = r(6738),
            n = r.n(o),
            i = r(7705),
            a = r.n(i)()(n());
        a.push([e.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
        var s = a;
      },
      28: function _(e, t, r) {
        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var o = r(6738),
            n = r.n(o),
            i = r(7705),
            a = r.n(i)()(n());
        a.push([e.id, ".hot-loading__icon{height:var(--spacer-8, 3rem);margin:var(--spacer-3, 0.75rem) 0;position:relative;width:var(--spacer-8, 3rem)}.hot-loading__fire svg{height:28px;left:50%;margin-left:-8px;margin-top:-15px;position:absolute;top:50%;width:18px}.hot-loading__fire svg path{fill:var(--brand-primary, #f04e23)}.hot-loading__progress{margin:0;text-align:center;width:100%}.hot-loading__progress:empty{display:none}.hot-loading__activity{-webkit-animation:spin var(--timing, 500ms) linear infinite;-moz-animation:spin var(--timing, 500ms) linear infinite;-o-animation:spin var(--timing, 500ms) linear infinite;animation:spin var(--timing, 500ms) linear infinite;border:var(--component-border-width, 0.0625rem) solid transparent;border-left-color:var(--gray-300, #c9ced4);-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;border-top-color:var(--gray-300, #c9ced4);display:block;height:var(--spacer-8, 3rem);margin:0 auto;position:relative;width:var(--spacer-8, 3rem)}:host{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;max-width:var(--structure-menu-width, 300px);padding:var(--spacer-3, 0.75rem) var(--spacer-4, 1rem);position:relative}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes spin{0%{-moz-transform:rotate(0deg);transform:rotate(0deg)}100%{-moz-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes spin{0%{-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}", ""]);
        var s = a;
      }
    },
        t = {};

    function r(o) {
      var n = t[o];
      if (void 0 !== n) return n.exports;
      var i = t[o] = {
        id: o,
        exports: {}
      };
      return e[o](i, i.exports, r), i.exports;
    }

    r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var o in t) {
        r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
          enumerable: !0,
          get: t[o]
        });
      }
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return function () {
      r.r(o);

      var e = require("@babel/runtime/helpers/classCallCheck");

      var t = r.n(e);

      var n = require("@babel/runtime/helpers/createClass");

      var i = r.n(n);

      var a = require("@babel/runtime/helpers/inherits");

      var s = r.n(a);

      var c = require("@babel/runtime/helpers/possibleConstructorReturn");

      var l = r.n(c);

      var d = require("@babel/runtime/helpers/getPrototypeOf");

      var f = r.n(d);

      var m = require("@babel/runtime/helpers/wrapNativeSuper");

      var u = r.n(m),
          p = r(5097);

      var g = function (e) {
        s()(a, e);
        var r,
            o,
            n = (r = a, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = f()(r);

          if (o) {
            var n = f()(this).constructor;
            e = Reflect.construct(t, arguments, n);
          } else e = t.apply(this, arguments);

          return l()(this, e);
        });

        function a(e) {
          var r;
          t()(this, a);
          var o = (r = n.call(this)).getTemplate(),
              i = document.createElement("template");
          i.innerHTML = o;
          var s = i.content.querySelector("style");
          return s && (s.innerHTML = "".concat(s.innerHTML, " ").concat(p.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(i, e), r.attachShadow({
            mode: "open"
          }), r.shadowRoot.appendChild(document.importNode(i.content, !0)), r;
        }

        return i()(a, [{
          key: "connectedCallback",
          value: function value() {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "";
          }
        }]), a;
      }(u()(HTMLElement));

      var v = g;
      var h = r(28);
      var b,
          y,
          x = "hot-loading";
      b = x, y = function (e) {
        s()(a, e);
        var r,
            o,
            n = (r = a, o = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = f()(r);

          if (o) {
            var n = f()(this).constructor;
            e = Reflect.construct(t, arguments, n);
          } else e = t.apply(this, arguments);

          return l()(this, e);
        });

        function a() {
          return t()(this, a), n.call(this, x);
        }

        return i()(a, [{
          key: "getTemplate",
          value: function value() {
            return "\n      <style>".concat(h.Z.toString(), '</style>\n      <div class="hot-loading__icon">\n        <div class="hot-loading__activity"></div>\n        <div class="hot-loading__fire">\n          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.8 151.4"><path d="M109.7 96.6c.7-13.5-3.9-35.6-15.3-53.6-.3-.5-.8-.3-.7.2.8 2.8.9 7.7-3.4 7.4-7.8-.5.3-17.1-16.8-28.6-.2-.1-.4-.1-.5 0-.1.1-.1.3 0 .4 1.2 2.2 1.9 9.1-.8 11.5-2.2 1.9-6.1 1.4-10-4.8-6.4-10.4-4-21.5.4-28.4.3-.6-.2-.8-.6-.7-23.4 7.8-28.1 35.4-33.1 45.4-.8 1.7-1.6 2.6-3 2.5-4.3-.3-1.2-9.4.3-12.6.1-.2 0-.4-.1-.5-.1-.1-.3 0-.4.1C13.5 47.5 2.6 69 .5 88.9c.1-.5-.2 1.6-.3 3.2 0 .6-.1 1.2-.1 1.8-.1.8-.1 1.5-.1 2.3-.2 30.3 24.2 55 54.6 55.2 30.2.2 54.9-24.1 55.2-54.3 0-.2-.1-.4-.1-.5zm-55 25.4c-14-.1-25.3-11.6-25.2-25.7.1-14 11.6-25.3 25.7-25.2 14 .1 25.3 11.6 25.2 25.6-.2 14.2-11.7 25.5-25.7 25.3z"></path></svg>\n        </div>\n      </div>\n      <div class="hot-loading__progress">\n        <slot></slot>\n      </div>\n    ');
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ["progress"];
          }
        }]), a;
      }(v), customElements.get(b) || customElements.define(b, y);
    }(), o;
  }();
});